fragment AccordionBlockFragment on accordionBlock_Entry {
  typeHandle
  heading
  backgroundGreen
  accordions {
    ... on accordionsBlock_Entry {
      id
      heading
      body
    }
  }
}
